/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { editEmbed } from 'state/actions/embedsState/embeds_status';
// component
import EditEmbedCTA from 'material/ctas/editembed/editembed';



/* ========== ~~~~~~~~~~ CTA : EDIT EMBED : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ appStatus, embedsState }) => ({
	currentPage: appStatus.currentPage,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
		dispatch(updatePageDetails(location));
    	dispatch(changePage(location))
    },
    editEmbed: embedUUID => dispatch(editEmbed(embedUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(EditEmbedCTA);
